import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { Col, Row } from '../Grid/index.js';
import Panel from '../Panel.js';
import GrowthDisplay from './GrowthDisplay.js';
const Stat = (props) => {
    const { stats, header, shouldHide } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(StatStyled, { header: header },
        React.createElement(Row, null,
            React.createElement(Col, { size: "md", width: "6" },
                React.createElement("p", null, lang.home.today),
                React.createElement("h3", { className: "this-one" },
                    stats && stats.today,
                    React.createElement("span", { className: "meta" },
                        React.createElement(GrowthDisplay, { prev: stats ? stats.yesterday : 0, curr: stats ? stats.today : 0 }),
                        React.createElement("span", null,
                            lang.home.yesterday,
                            " ",
                            stats && stats.yesterday)))),
            React.createElement(Col, { size: "md", width: "6" },
                React.createElement("p", null, lang.home.thisMonth),
                React.createElement("h3", { className: "this-one" },
                    stats && stats.thisMonth,
                    React.createElement("span", { className: "meta" },
                        React.createElement(GrowthDisplay, { prev: stats ? stats.lastMonth : 0, curr: stats ? stats.thisMonth : 0 }),
                        React.createElement("span", null,
                            lang.home.lastMonth,
                            " ",
                            stats && stats.lastMonth)))),
            stats && !!stats.total && !shouldHide && (React.createElement(Col, { size: "md", width: "12" },
                React.createElement(Total, null,
                    React.createElement(Row, null, typeof stats.total === 'number' ? (React.createElement(Col, { size: "md", width: "6", className: "total-container" },
                        React.createElement("div", { className: "total-key" }, props.totalLabel),
                        React.createElement("div", { className: "total-value" }, stats && stats.total))) : (stats.total.map((type) => (React.createElement(Col, { size: "md", width: "3", key: (type && props.getLabel && props.getLabel(type)) || ' ' },
                        React.createElement("div", { className: "total-key" }, props.getLabel && props.getLabel(type)),
                        React.createElement("div", { className: "total-value" },
                            ' ',
                            props.statType && type[props.statType]))))))))))));
};
export default Stat;
export const Total = styled.div `
  border-top: 1px solid ${THEME.BORDER_STRONG};
  margin-top: 10px;

  .total-container {
    overflow: hidden;
  }

  div.total-key,
  div.total-value {
    font-size: 0.8em;
    display: inline-block;
    margin-top: 10px;
  }

  div.total-key {
  }

  div.total-value {
    font-weight: bold;
    margin-left: 0.4em;
  }
`;
export const StatStyled = styled(Panel) `
  p {
    color: ${THEME.TEXT_MUTED};
    margin: 0;
  }

  .this-one {
    font-size: 2.4em;
    margin: 0.1em 0 0 0;
    .meta {
      font-size: 0.35em;
      display: inline-block;
      margin-left: 5px;

      > span {
        display: block;
      }

      & > span:last-child {
        font-size: 0.7em;
      }
    }

    div.meta {
      display: block;
    }

    .positive {
      color: ${THEME.SUCCESS};
    }
    .negative {
      color: ${THEME.DANGEROUS};
    }
  }
`;
//# sourceMappingURL=Stat.js.map